import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import api, { getRoles } from '../../utils/authUtils';

const ProtectedSpeakerRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState('checking');
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await api.get('/api/protected');
        const roles = getRoles();
        // Checks the full role set, not just the account's primary role - an
        // ATTENDEE (or any other) account invited as a speaker has 'SPEAKER'
        // granted alongside its primary role, and belongs here just as much
        // as a SPEAKER-primary account.
        setAuthStatus(roles.includes('SPEAKER') || roles.includes('ADMIN') ? 'authenticated' : 'unauthenticated');
      } catch (error) {
        if (error.message === 'Session expired. Please login again.') {
          navigate('/speaker/login?session_expired=true', { replace: true });
        } else {
          setAuthStatus('unauthenticated');
        }
      }
    };

    checkAuth();
  }, [navigate]);

  if (authStatus === 'checking') {
    return <div>Loading...</div>;
  }

  if (authStatus === 'unauthenticated') {
    return <Navigate to="/speaker/login" replace />;
  }

  return children;
};

export default ProtectedSpeakerRoute;
